






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";
import http from "../../plugins/http";
import * as Common from "../../commons/common";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setGauthCredentials", context.root.$route.query.credentials);

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/google_sessions/teacher_login`, {token: context.root.$route.query.t}).then(response => {
        
        // トークン設定
        var token = response.data.user.access_token
        document.cookie = 'access_token=' + token;
        document.cookie = 'smarky_user_id=' + response.data.user.id;

        context.root.$store.commit("setCurrentUser", response.data.user);
        context.root.$store.commit("setSchools", response.data.schools);
        context.root.$store.commit("setCurriculums", response.data.curriculums);
        context.root.$store.commit("setViewPoints", response.data.view_points);
        
        context.root.$router.push('/teacher_site/sheet_list').catch(() => {});
      })
      .catch(error=>{
        // エラーの場合はログイン画面に戻る
        context.root.$router.push(`/?error_kind=${error.response.data.error_kind}`).catch(err => {});
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    }
  }
})
